// extracted by mini-css-extract-plugin
export var container = "productItemPage-module--container--1EgL_";